import { ClientModel } from '@skylab-shared/dataModel';
import { GusData } from '../gus/queries/gus-data-by-tin.query-base';
import { EmailUtils } from './email-utils';


export class ClientUtils {
    public static setGusData(client: ClientModel, data: GusData): void {
        const postOfficeInOtherCity = data.city !== data.postOfficeCity && data.postOfficeCity !== '';
        const cityInAddress = `${postOfficeInOtherCity ? `${data.city}${data.street ? ', ' : ''}` : ''}`;
        const address = `${cityInAddress} ${data.street} ${data.houseNumber}${data.apartmentNumber ? '/' + data.apartmentNumber : ''}`
            .trim()
            .replace(/\s{2,}/, ' ');
        client.name = data.name;
        client.address = address;
        client.zipCode = data.zipCode;
        client.city = postOfficeInOtherCity ? data.postOfficeCity : data.city;
        client.emails = data.email ? EmailUtils.extractEmails(data.email) : client.emails;
        client.phone1 = data.phone;
        client.website = data.www;
    }

    public static getNormalizedTin(tin: string): string {
        return tin.replace(/[\s\-]+/g, '');
    }
}
